export var Public;
(function (Public) {
    function bindScope(client) {
        return {
            DownloadPublicContentPdf: client.bindCallable({
                name: 'DownloadPublicContentPdf',
                scope: 'public',
                path: '/api/public/download-public-content-pdf',
                method: 'post',
                kind: 'api',
            }),
        };
    }
    Public.bindScope = bindScope;
})(Public || (Public = {}));
//# sourceMappingURL=public.js.map